import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const VouchersDefaultSchemas = DefaultSchemas

export const VouchersDataSchemas = zod.object({
  pluCode: zod.string().nullable(),
  voucherCode: zod.string(),
  name: zod.string(),
  description: zod.string().nullable(),
  endDate: zod.string(),
  status: zod.string(),
  voucherValue: zod.number(),
  imageUrl: zod.string().nullable(),
  startDate: zod.string(),
  campaign: zod.string().nullable(),
  voucherType: zod.string(),
  redemptionDate: zod.string().nullable(),
  redemptionStore: zod.string().nullable(),
  redeemableAt: zod.string().array(),
  offerId: zod.string().nullable(),
  voucherId: zod.number().nullable(),
  voucherTenderId: zod.number().nullable().optional(),
})

export const VouchersAPISchemas = VouchersDefaultSchemas.merge(
  zod.object({
    vouchers: zod.array(VouchersDataSchemas),
  })
)

export const VouchersFetchParamsSchemas = zod.object({
  traderId: zod.number(),
  voucherName: zod.string().optional(),
  voucherCode: zod.string().optional(),
  status: zod.string().optional(),
  startDate: zod.string().optional(),
  endDate: zod.string().optional(),
  pSize: zod.number().optional(),
  pNumber: zod.number().optional(),
})

export const VouchersStatusesDataSchemas = zod.object({
  label: zod.string(),
  value: zod.string(),
})

export const VouchersStatusesAPISchemas = VouchersDefaultSchemas.merge(
  zod.object({
    vouchersStatus: zod.array(VouchersStatusesDataSchemas),
  })
)

export const VoucherStatusUpdateFormSchemas = zod.object({
    voucherId: zod.number().nullable(),
    voucherTenderId: zod.number().nullable(),
    voucherStatusId: zod.number(),
})

export interface VoucherStatusUpdateTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
}

export type UpdateVouchersStatusFormTypes = zod.infer<typeof VoucherStatusUpdateFormSchemas>;
